var setSpecies = require('../internals/set-species');

// `Array[@@species]` getter
// https://tc39.es/ecma262/#sec-get-array-@@species
setSpecies('Array');



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-app-polyfill/node_modules/core-js/modules/es.array.species.js
// module id = 975
// module chunks = 0